import { render, staticRenderFns } from "./AddRecibo.vue?vue&type=template&id=3548ef84"
import script from "./AddRecibo.vue?vue&type=script&lang=js"
export * from "./AddRecibo.vue?vue&type=script&lang=js"
import style0 from "./AddRecibo.vue?vue&type=style&index=0&id=3548ef84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports